import React, { Component } from 'react'
import autoBind from 'react-autobind'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { bindActionCreators } from 'redux'
import { Container, Image, Segment } from 'semantic-ui-react'

import back from '../../assets/images/angle-fuchsia.png'
import Modules from '../common/modules'
import CompletedEducationalContent from '../common/completed-educational-content'
import { tr } from '../../helpers/languages'
import { send } from '../../helpers/requests'
import { actions as participants } from '../../store/actions/participants'

class ParticipantEducationalContent extends Component {
    constructor (props) {
        super(props)
        this.state = {
            educationalContent: []
        }
        autoBind(this)
    }

    componentDidMount () {
        // Fetch the educational content.
        this.setState({ educationalContent: [] })
        this.fetchEducationalContent(this.props.module)
        document.getElementById('completed-exercises').scrollTop = 0
    }

    componentWillReceiveProps (nextProps) {
        if (this.props.module !== nextProps.module) {
            // Fetch the educational content.
            this.setState({ educationalContent: [] })
            this.fetchEducationalContent(nextProps.module)
            document.getElementById('completed-exercises').scrollTop = 0
        }
    }

    // Fetches the participant's educational content for the given module.
    fetchEducationalContent (module) {
        if (!module) {
            return
        }
        // eslint-disable-next-line no-console
        console.log('Fetch educational content.')
        send({
            method: 'GET',
            tokens: this.props.userTokens,
            url: `/patients/${this.props.match.params.id}/educational-content/${module}`
        })
            .then((response) => {
                // eslint-disable-next-line no-console
                console.log('Fetched educational content.')
                var edu_content = [];
                edu_content.push(response.data)
                this.setState({
                    educationalContent: edu_content
                })
            })
            .catch((error) => {
                // Failed to fetch eductional content.
                // eslint-disable-next-line no-console
                console.error('Failed to fetch eductional content.', error)
                // Hide the error.
                this.setState({ educationalContent: [] })
            })
    }

    // Changes to the module with the given ID.
    changeModule (module) {
        this.props.changeLocation({ module })
    }

    render () {
        return (
            <Container className='participant-exercises'>
                <Segment
                    className='navigation-item'
                    onClick={(_e) => { this.props.onChangeSubsection(undefined) }}
                >
                    <Image src={back}/>
                    {tr('EDUCATIONAL_MATERIAL')}
                </Segment>
                <Modules
                    language={this.props.language}
                    timezone={this.props.timezone}
                    onChangeModule={(module) => { this.changeModule(module) }}
                />
                <CompletedEducationalContent
                    educationalContent={this.state.educationalContent}
                />
            </Container>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        language: state.settings.language,
        module: state.participants.location.module,
        timezone: state.settings.timezone,
        userTokens: state.users.userTokens
    }
}

const mapDispatchToProps = (dispatch) => {
    const _participants = bindActionCreators(participants, dispatch)
    return {
        changeLocation: _participants.changeLocation
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ParticipantEducationalContent))



// WEBPACK FOOTER //
// ./src/components/participant-educational-content/index.js